import { colorRed400, colorRed100 } from "@amzn/meridian-tokens/base/color";
import { THEME_COLOR } from "../../styles/colors";

// Fallback-poll cadence while the WebSocket is disconnected. Shared so both tabs poll in step.
export const POLL_INTERVAL_MS = 5000;

// Height of a session tab's body: viewport minus the masthead + session tab bar + footer chrome
// above/below it. Shared so the Agenda and Action Items tabs bound their scroll areas identically.
export const SESSION_TAB_BODY_HEIGHT = "calc(100vh - 131px)";

// Inline delete-confirmation prompt, shared so the two tabs can't drift apart on wording.
export const DELETE_CONFIRM_LABEL = "Delete this item?";

// "Add" button themes shared across Agenda and Action Items.
// primary (empty state): solid teal call-to-action, slightly smaller than the
// small preset (tighter padding + label).
// link (populated-list footer): subtle grey link.
export const addButtonPrimaryTheme = {
  buttonBackgroundColorPrimaryDefault: THEME_COLOR.TEAL_GREEN,
  buttonBackgroundColorPrimaryHover: THEME_COLOR.DEEP_TEAL,
  buttonBackgroundColorPrimaryPressed: THEME_COLOR.DEEP_TEAL,
  buttonSpacingInsetHorizontalSmall: 8,
  buttonLabelSmallFontSize: 13,
};

export const addButtonLinkTheme = {
  buttonForegroundColorLinkDefault: THEME_COLOR.MID_GRAY,
  buttonForegroundColorLinkHover: THEME_COLOR.MID_GRAY,
  buttonForegroundColorLinkPressed: THEME_COLOR.MID_GRAY,
};

// Red trash icon button with a light-red highlight on hover. Shared across
// Agenda and Action Items for destructive delete controls.
export const deleteButtonTheme = {
  buttonForegroundColorIconDefault: colorRed400,
  buttonBackgroundColorIconHover: colorRed100,
};
